export default {
    activeTeamMembers: 'メンバー',
    admin: '管理者',
    apiApplication: 'APIで連携したアプリケーション',
    apiApplications: 'APIで連携したアプリケーション',
    clearSearch: 'クリア',
    distributeLicenses: '一般権限を付与',
    emailVerificationBanner:
        'MakeLeapsでは、より良いセキュリティーとサービスを提供するため、メンバーを招待するには「本メールアドレス」の認証をお願いしています。',
    emailVerificationBannerButton: 'メール設定へ',
    invite: {
        bulkInvite: '一括で招待（インポート）',
        inviteOneMember: '個別に招待',
        inviteTeamMembers: 'メンバーを招待',
    },
    invited: '招待中',
    licensed: '一般権限',
    name: 'メンバー名',
    noResults: '該当が見つかりませんでした',
    ownerAdmin: '所有者/管理者',
    rightsForMakeLeapsApi:
        '<0>登録されているAPIキー</0>には、メンバーと同じように権限の設定ができます。',
    transferOwnership: '所有者を変更',
    usageLimitMessage:
        'メンバーは無制限で追加できるものの、一般権限メンバーの上限（{{activeUserLimit}}）に達しています。 一般権限メンバーを増やすには<0>プランをアップグレード</0>してください。',
    usageLimitUnlimited: '{{planName}}sプランではメンバーの人数は無制限です。',
    viewRights: '権限を表示',
    you: '利用中',
};
